import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEDITemplateSlideout extends Layout {
    labelAuthorizationInformationISA0102: Label;
    labelInterchangeCtlVersionNoISA1112: Label;
    labelInterchangeReceiverIDISA0708: Label;
    labelInterchangeSenderIDISA0506: Label;
    labelSecurityInformationISA0304: Label;
    panel1: Panel;
    panel2: Panel;
    panelAuthorizationInfo: Panel;
    panelHeading: Panel;
    panelInterchangeCtl: Panel;
    panelInterchangeReceiver: Panel;
    panelInterchangeSender: Panel;
    panelSecurityInfo: Panel;
    sourceEdiTemplateDetail: DataSource;
    textboxAckRequired: Textbox;
    textboxAppReceiverCode: Textbox;
    textboxAppReceiverId: Textbox;
    textboxAppSenderCode: Textbox;
    textboxAppSenderId: Textbox;
    textboxAuthenInfo: Textbox;
    textboxAuthenInfoQual: Textbox;
    textboxCtlVersion: Textbox;
    textboxCtlVersionQual: Textbox;
    textboxEleSeparator: Textbox;
    textboxElementChar: Textbox;
    textboxEndOfLine1: Textbox;
    textboxEndOfLine1Char: Textbox;
    textboxEndOfLine2: Textbox;
    textboxEndOfLine2Char: Textbox;
    textboxFunctionalId: Textbox;
    textboxId: Textbox;
    textboxIndustry: Textbox;
    textboxName: Textbox;
    textboxReceiverId: Textbox;
    textboxReceiverQual: Textbox;
    textboxSecurInfo: Textbox;
    textboxSecurInfoQual: Textbox;
    textboxSenderId: Textbox;
    textboxSenderQual: Textbox;
    textboxStandard: Textbox;
    textboxSubElementChar: Textbox;
    textboxSubeleSeparator: Textbox;
    textboxTestIndicator: Textbox;
    textboxTransactionSet: Textbox;
    textboxTransactionType: Textbox;
    textboxVersion: Textbox;
}
